import { render, staticRenderFns } from "./Ques.vue?vue&type=template&id=ae2cc9c8&scoped=true"
import script from "./Ques.vue?vue&type=script&lang=js"
export * from "./Ques.vue?vue&type=script&lang=js"
import style0 from "./Ques.vue?vue&type=style&index=0&id=ae2cc9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2cc9c8",
  null
  
)

export default component.exports